import { FormControl, Select } from '@atlas-design-system/react'
import { EMPTY_SELECT_OPTION } from 'common/constants'
import { matchFromStart } from 'common/helpers'
import { useReferenceData } from 'common/hooks/use-reference-data.hook'
import { SelectOption } from 'common/types'
import { useField } from 'formik'
import React, { useCallback } from 'react'

type EquipmentTypeSelectProps = {
  name: string
  disabled?: boolean
}
export const EquipmentTypeSelect: React.FC<EquipmentTypeSelectProps> = ({
  disabled = false,
  ...props
}) => {
  const [field, , helpers] = useField(props)
  const { setValue } = helpers

  const { equpmentTypeCodesSelectOptions } = useReferenceData()

  const handleChange = useCallback(
    (selectedOption: SelectOption) => {
      setValue(selectedOption)
    },
    [setValue],
  )

  return (
    <FormControl label="Equipment Type" disabled={disabled}>
      <Select
        next
        {...field}
        {...props}
        data-testid="equipment-type-select"
        isSearchable
        className="atls-select-height-360"
        onChange={handleChange}
        options={[EMPTY_SELECT_OPTION, ...equpmentTypeCodesSelectOptions]}
        isDisabled={disabled}
        filterOption={matchFromStart}
      />
    </FormControl>
  )
}
